// extracted by mini-css-extract-plugin
module.exports = {"form":"index2_form__x9r6Q","title":"index2_title__3owKJ","form-control":"index2_form-control__3AH_J","button-lg":"index2_button-lg__3FvOv"};